import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import commonFn from "@/commons/commonFunction";
import store from "@/stores/store";

class TransactionControlAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "transactioncontrol";
  /**
   *  Lấy dữ liệu danh sách vai trò
   */
  async getCrossCheckingDetail(period, periodEnd) {
    // Build tham số
    let request = {
      url:
        window._apis.Management +
        "/transactioncontrol/crosscheckingdetail?period=" +
        period +
        "&periodEnd=" +
        periodEnd,
    };
    // Call api
    return await httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách
   */
  async export(payload) {
    //Lấy token xuất khẩu
    let request = {
      url: window._apis[this.apiName] + "/Common/exporttoken",
    };

    let res = await httpClient.getAsync(request);
    if (res) {
      let token = res.temporalToken;
      //format tên file xuất khẩu
      // let userInfo = JSON.parse(commonFn.getLocalStorage("User"));
      // check user
      let userInfo = store.state.context.User;
      if (userInfo) {
        let url =
          this.getAPIUrl() +
          "/export/merchant?filter=" +
          encodeURIComponent(btoa(payload.filter)) +
          "&fileName=" +
          encodeURI(payload.fileName || "") +
          "&merchantcode=" +
          userInfo.merchant_code +
          "&token=" +
          encodeURIComponent(token) +
          "&period=" +
          payload.period.toISOString();
        let req = {
          url: url,
          responseType: "blob",
        };
        var result = await this.getAsync(req);
        const urlResult = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement("a");
        link.href = urlResult;
        link.setAttribute("download", payload.fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    }
  }
}

export default new TransactionControlAPI();
